<template>
  <div
    :id="componentId"
    class="zt-header-layout w-full bg-zt-primary-200 relative flex justify-center items-center lg:bg-white lg:shadow-lg"
  >
    <div class="zt-header-logo-business absolute left-0 hidden lg:block">
      <slot name="header-logo"></slot>
    </div>
    <div class="flex justify-center items-center lg:w-full lg:mr-20">
      <div class="lg:ml-auto">
        <slot name="header-actions"></slot>
      </div>
    </div>
    <div class="absolute right-0 items-center flex justify-center">
      <div
        :aria-owns="computedOwns"
        v-on="listeners"
        ref="ztHeaderButtonAvatar"
        class="inline-flex justify-center cursor-pointer hidden mr-6 lg:block"
        @click.stop
      >
        <slot name="header-avatar"></slot>
      </div>
    </div>
    <transition :name="changeAnimateStyle">
      <div
        :id="computedOwns"
        v-show="isActiveMenu"
        ref="ztHeaderMenu"
        :style="cords"
        class="zt-header-menu w-full lg:w-72 lg:shadow-lg fixed bg-white pt-4 rounded-t-zt-lg lg:pt-0 lg:rounded-zt-none overflow-hidden"
      >
        <span
          class="w-12 h-px border-2 border-zt-dark-200 rounded block m-auto lg:hidden"
        />
        <slot name="header-list-item"></slot>
      </div>
    </transition>
    <zt-overlay :active="isActiveOverlay" :z-index="99" />
  </div>
</template>

<script>
import utils from '../../../../utils/helpers'
import useWindowResize from '../../../../hooks/useWindowResize'
export default {
  name: 'ztHeaderBar',
  inheritAttrs: false,
  data() {
    return {
      isActiveMenu: false,
      isActiveOverlay: false,
      cords: {},
      componentId: '',
      windowWidth: ''
    }
  },
  watch: {
    isActiveMenu() {
      if (this.isActiveMenu) {
        utils.insertContent(this.$refs.ztHeaderMenu)
      }
    }
  },
  computed: {
    listeners() {
      const listeners = { ...this.$attrs };
      for (const key in this.$listeners) {
        if (!listeners[key]) {
          listeners[key] = (...args) => this.$emit(key, ...args);
        }
      }
      return {
        ...listeners,
        click: event => {
          this._onClick(event)
        },
        blur: event => {
          this._onBlur(event)
        }
      }
    },
    computedOwns() {
      return `menu-${this._uid}`
    },
    isWindowMobile() {
      return this.windowWidth.width < 1024
    },
    changeAnimateStyle() {
      return this.isWindowMobile ? 'header-translate' : 'header-opacity'
    }
  },
  methods: {
    _onClick(event) {
      this.$emit('focus', event)
      this.isActiveMenu = true
      if (this.isWindowMobile) this.isActiveOverlay = true
      document.addEventListener('click', this.clickBlur)
      this.$nextTick(() => {
        this.cords = this.positionMenu()
      })
    },
    _onBlur(event) {
      if (
        event.relatedTarget
          ? !event.relatedTarget.closest('.zt-header-menu')
          : false
      ) {
        this.closeMenu()
      }
      this.$emit('blur', event)
    },
    clickBlur(event) {
      let menuContent = event.target.closest('.zt-header-menu')
      if (!menuContent) {
        this.closeMenu()
        this.cords = this.positionMenu()
      }
    },
    closeMenu() {
      this.isActiveMenu = false
      this.isActiveOverlay = false
      document.removeEventListener('click', this.clickBlur)
    },
    positionMenu() {
      let styles = {}
      let headerButtonMenu = this.isWindowMobile
        ? this.$refs.ztHeaderButtonMenu
        : this.$refs.ztHeaderButtonAvatar
      let headerMenu = this.$refs.ztHeaderMenu
      let topPos = 0
      let leftPos = 0
      if (this.isWindowMobile) {
        styles = {
          left: `${leftPos}px`,
          bottom: `${topPos}px`,
          zIndex: 100
        }
      } else {
        topPos =
          headerButtonMenu.getBoundingClientRect().top +
          headerButtonMenu.clientHeight +
          15
        leftPos =
          headerButtonMenu.getBoundingClientRect().left -
          headerMenu.clientWidth +
          headerButtonMenu.clientWidth -
          headerButtonMenu.clientWidth / 4
        styles = {
          left: `${leftPos}px`,
          top: `${topPos}px`,
          zIndex: 11
        }
      }
      return styles
    }
  },
  mounted() {
    this.windowWidth = useWindowResize(this)
    this.componentId = this._uid
  },
  beforeDestroy() {
    let [parent] = document.getElementsByTagName('body')
    if (
      parent &&
      this.$refs.ztHeaderMenu &&
      this.$refs.ztHeaderMenu.parentNode === parent
    ) {
      parent.removeChild(this.$refs.ztHeaderMenu)
      document.removeEventListener('click', this.clickBlur)
    }
  }
}
</script>

<style
  scoped
  lang="css"
  src="../../../../styles/components/ztHeaderBar.css"
></style>
